var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomersupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.076 80.242 H 4.261 C 2.467 80.242 1 78.775 1 76.982 V 52.81 c 0 -1.793 1.467 -3.261 3.261 -3.261 h 10.815 V 80.242 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.076 81.242 H 4.261 C 1.911 81.242 0 79.331 0 76.981 V 52.81 c 0 -2.35 1.911 -4.261 4.261 -4.261 h 10.815 c 0.552 0 1 0.447 1 1 v 30.693 C 16.076 80.795 15.628 81.242 15.076 81.242 z M 4.261 50.549 C 3.014 50.549 2 51.563 2 52.81 v 24.172 c 0 1.246 1.014 2.261 2.261 2.261 h 9.815 V 50.549 H 4.261 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.409 49.626 h -2 c 0 -21.432 -17.437 -38.868 -38.869 -38.868 S 5.672 28.194 5.672 49.626 h -2 c 0 -22.535 18.333 -40.868 40.869 -40.868 C 67.075 8.758 85.409 27.091 85.409 49.626 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.924 80.242 h 10.815 c 1.793 0 3.261 -1.467 3.261 -3.261 V 52.81 c 0 -1.793 -1.467 -3.261 -3.261 -3.261 H 74.924 V 80.242 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.739 81.242 H 74.924 c -0.553 0 -1 -0.447 -1 -1 V 49.549 c 0 -0.553 0.447 -1 1 -1 h 10.815 c 2.35 0 4.261 1.911 4.261 4.261 v 24.172 C 90 79.331 88.089 81.242 85.739 81.242 z M 75.924 79.242 h 9.815 c 1.246 0 2.261 -1.015 2.261 -2.261 V 52.81 c 0 -1.246 -1.015 -2.261 -2.261 -2.261 h -9.815 V 79.242 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.934 16.637 l -4.436 4.816 c -5.201 -3.292 -11.347 -5.225 -17.957 -5.225 s -12.757 1.933 -17.957 5.225 l -4.436 -4.816 C 36.445 7.47 51.374 7.47 66.934 16.637 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.498 22.453 c -0.185 0 -0.37 -0.051 -0.535 -0.155 c -5.24 -3.316 -11.265 -5.07 -17.422 -5.07 c -6.158 0 -12.183 1.753 -17.423 5.07 c -0.407 0.259 -0.943 0.189 -1.27 -0.167 l -4.436 -4.816 c -0.2 -0.217 -0.294 -0.512 -0.256 -0.805 c 0.038 -0.293 0.203 -0.554 0.452 -0.714 c 14.574 -9.344 29.994 -9.351 45.834 -0.02 c 0.26 0.154 0.438 0.417 0.481 0.715 s -0.049 0.602 -0.254 0.824 l -4.436 4.816 C 63.038 22.342 62.77 22.453 62.498 22.453 z M 44.541 15.228 c 6.259 0 12.389 1.706 17.781 4.941 l 3.029 -3.29 C 50.96 8.792 36.958 8.782 23.699 16.846 l 3.061 3.323 C 32.151 16.934 38.28 15.228 44.541 15.228 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,59,59)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 69.551 c -0.552 0 -1 -0.447 -1 -1 V 54.24 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 14.311 C 7 69.104 6.552 69.551 6 69.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(77,77,77)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 76.551 c -0.552 0 -1 -0.447 -1 -1 v -3 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 3 C 7 76.104 6.552 76.551 6 76.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(77,77,77)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84 69.551 c -0.553 0 -1 -0.447 -1 -1 V 54.24 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 14.311 C 85 69.104 84.553 69.551 84 69.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(77,77,77)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84 76.551 c -0.553 0 -1 -0.447 -1 -1 v -3 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 3 C 85 76.104 84.553 76.551 84 76.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(77,77,77)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersupport);
export default __webpack_public_path__ + "static/media/customersupport.a54560d862ba6d2cd4856ad491652179.svg";
export { ForwardRef as ReactComponent };